import { Reducer } from "../../lib/redux";
import { IDeviceMovement, IEventType, DeviceMovementActionTypes } from "./types";

// eslint-disable-next-line complexity
export let deviceMovement: Reducer<IDeviceMovement> = (state = {}, action): IDeviceMovement => {
    switch (action.type) {
        case DeviceMovementActionTypes.SET_PUB_SUB_PAYLOAD: {
            return {
                ...state,
                pubSubPayload: action.payload,
                lastPayloadUpdated: IEventType.pubSub
            };
        }
        case DeviceMovementActionTypes.SET_IOX_DATA_PAYLOAD: {
            return {
                ...state,
                ioxDataPayload: action.payload,
                lastPayloadUpdated: IEventType.ioxData
            };
        }
        case DeviceMovementActionTypes.SET_STATE_UPDATE: {
            return {
                ...state,
                stateUpdate: action.payload,
                lastPayloadUpdated: IEventType.stateUpdate
            };
        }
        case DeviceMovementActionTypes.SET_LAST_PAYLOAD_UPDATED: {
            return {
                ...state,
                lastPayloadUpdated: undefined
            };
        }
        case DeviceMovementActionTypes.CLEAR_STATE_UPDATE: {
            return {
                ...state,
                stateUpdate: undefined
            };
        }
        default: {
            return state;
        }
    }

};